import { List,Map } from "immutable";

import { ConstraintTypes } from "../../constants/constraints";
import { createFromJS,immutableRecords } from "../../types";
import combineReducersWithGlobal from "../combineReducersWithGlobal";
import { calendarSelectors } from "../definition/calendar";
import dateFunctions from "../definition/calendar/dateFunctions";
import dateWithLegalPrecision from "../definition/calendar/dateFunctions/dateWithLegalPrecision";
import timespanWithLegalPrecision from "../definition/calendar/dateFunctions/timespanWithLegalPrecision";
import { itemActionTypes } from "../items";
import { actionTypes } from "./actions";
import selectors from "./selectors";

// const isConstraintAffected = (c, ids) => {
//   const g = c.id;
//   return Array.isArray(ids) ? ids.indexOf(g) !== -1 : g === ids;
// };

// const doesConstraintMatchRelativeValues = (c, subjects, subjectTarget, object, objectTarget, comparison, offset) => {
//   // TODO: This one is tricky because we need to handle inverse also
//   if (
//     c.subjectTarget === subjectTarget &&
//     c.object === object &&
//     c.objectTarget === objectTarget &&
//     c.comparison === comparison &&
//     c.offset === offset &&
//     subjects.indexOf(c.subject) >= 0
//   ) {
//     return true;
//   }
//   return false;
// };

// const doesConstraintMatchDateValues = (c, subjects, subjectTarget, comparison, date) => {
//   if (
//     c.subjectTarget === subjectTarget &&
//     c.comparison === comparison &&
//     c.date.timestamp === date.timestamp &&
//     subjects.indexOf(c.subject) >= 0
//   ) {
//     return true;
//   }
//   return false;
// };

// const doesConstraintMatchDatePartValues = (c, subjects, subjectTarget, partPrecision, partValue) => {
//   if (
//     c.subjectTarget === subjectTarget &&
//     c.partPrecision === partPrecision &&
//     c.partValue === partValue &&
//     subjects.indexOf(c.subject) >= 0
//   ) {
//     return true;
//   }
//   return false;
// };

// const doesConstraintMatchValues = (c, action) => {
//   if (c.constraintType !== action.constraintType) {
//     return false;
//   }
//   if (action.constraintType === ConstraintTypes.Date) {
//     return doesConstraintMatchDateValues(c, action.subjects, action.subjectTarget, action.comparison, action.date);
//   }
//   if (action.constraintType === ConstraintTypes.DatePart) {
//     return doesConstraintMatchDatePartValues(
//       c,
//       action.subjects,
//       action.subjectTarget,
//       action.partPrecision,
//       action.partValue
//     );
//   }
//   if (action.constraintType === ConstraintTypes.Relative) {
//     return doesConstraintMatchRelativeValues(
//       c,
//       action.subjects,
//       action.subjectTarget,
//       action.object,
//       action.objectTarget,
//       action.comparison,
//       action.offset
//     );
//   }
//   return false;
// };

const createDatePartConstraints = (state, ids, subjects, subjectTarget, partPrecision, partValue) => {
  return state.withMutations(s => {
    for (let i = 0; i < ids.length; i++) {
      const rId = ids[i];
      const subjectId = subjects[i];
      s.set(
        rId,
        immutableRecords.ConstraintRecord({
          constraintType: ConstraintTypes.DatePart,
          id: rId,
          subject: subjectId,
          subjectTarget,
          partPrecision,
          partValue
        })
      );
    }
  });
};

const createDateConstraints = (state, ids, subjects, subjectTarget, comparison, date) => {
  return state.withMutations(s => {
    for (let i = 0; i < ids.length; i++) {
      const rId = ids[i];
      const subjectId = subjects[i];
      s.set(
        rId,
        immutableRecords.ConstraintRecord({
          constraintType: ConstraintTypes.Date,
          id: rId,
          subject: subjectId,
          subjectTarget,
          comparison,
          date: date
        })
      );
    }
  });
};

const createRelativeConstraints = (state, ids, subjects, subjectTarget, object, objectTarget, comparison, offset) => {
  return state.withMutations(s => {
    for (let i = 0; i < ids.length; i++) {
      const rId = ids[i];
      const subjectId = subjects[i];
      s.set(
        rId,
        immutableRecords.ConstraintRecord({
          constraintType: ConstraintTypes.Relative,
          id: rId,
          subject: subjectId,
          subjectTarget,
          object,
          objectTarget,
          comparison,
          offset
        })
      );
    }
  });
};

const createConstraints = (state, action) => {
  if (action.constraintType === ConstraintTypes.Relative) {
    return createRelativeConstraints(
      state,
      action.ids,
      action.subjects,
      action.subjectTarget,
      action.object,
      action.objectTarget,
      action.comparison,
      action.offset
    );
  }
  if (action.constraintType === ConstraintTypes.Date) {
    return createDateConstraints(
      state,
      action.ids,
      action.subjects,
      action.subjectTarget,
      action.comparison,
      action.date
    );
  }
  if (action.constraintType === ConstraintTypes.DatePart) {
    return createDatePartConstraints(
      state,
      action.ids,
      action.subjects,
      action.subjectTarget,
      action.partPrecision,
      action.partValue
    );
  }
  return state;
};

const moveBySpan = (obj, spanChange, calendar) => {
  const date = dateFunctions.dateByAddingSpan(calendar, obj.date, immutableRecords.TimespanRecord(spanChange));

  return obj.set("date", date);
};

const changePrecisionForCalendar = (obj, calendar) => {
  let date = dateWithLegalPrecision(obj.date, calendar);
  let offset = timespanWithLegalPrecision(obj.date, obj.offset, calendar);

  return obj.merge({
    date,
    offset
  });
};

const byId = (state = Map(), action, globalState) => {
  const calendar = calendarSelectors.getCalendar(globalState);
  switch (action.type) {
    case actionTypes.CREATE_CONSTRAINTS:
      return createConstraints(state, action);
    case actionTypes.REMOVE_CONSTRAINTS:
      return state.deleteAll(action.ids);
    // case actionTypes.REMOVE_CONSTRAINTS_WITH_VALUES: {
    //   return state.filter(d => !doesConstraintMatchValues(d, action));
    // }
    case itemActionTypes.DELETE_ITEMS: {
      const constraintIds = selectors.getDateConstraintsToBeDeletedWithItems(globalState, action.ids);
      return state.deleteAll(constraintIds);
    }
    case actionTypes.MOVE_BY_TIMESPAN:
      return state.map(obj => moveBySpan(obj, action.spanChange, calendar));
    case actionTypes.ADJUST_PRECISION_FOR_CALENDAR_TYPE: {
      return state.map(obj => changePrecisionForCalendar(obj, calendar));
    }
    default:
      return state;
  }
};

const allIds = (state = List(), action, globalState) => {
  switch (action.type) {
    case actionTypes.CREATE_CONSTRAINTS:
      return state.push(...action.ids);
    case actionTypes.REMOVE_CONSTRAINTS:
      return state.filter(id => action.ids.indexOf(id) === -1);
    case itemActionTypes.DELETE_ITEMS: {
      const constraintIds = selectors.getDateConstraintsToBeDeletedWithItems(globalState, action.ids);
      return state.filter(id => constraintIds.indexOf(id) === -1);
    }
    default:
      return state;
  }
};

export default combineReducersWithGlobal(createFromJS.IdReferenceList("ConstraintRecord", {}), {
  byId,
  allIds
});
